import { render } from "./NumberArea.vue?vue&type=template&id=ac263d08&scoped=true&ts=true"
import script from "./NumberArea.vue?vue&type=script&lang=ts"
export * from "./NumberArea.vue?vue&type=script&lang=ts"

import "./NumberArea.vue?vue&type=style&index=0&id=ac263d08&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac263d08"]])

export default __exports__